import Vue from 'vue';
import { jsonCopy } from '@/utils/json';

export const filterBus = new Vue();

export function filterCards (filters, cards, currentFilters) {
    return cards.filter(card => {
        return !Object.keys(currentFilters).find(key => {
            if (Object.prototype.hasOwnProperty.call(card.filterProperties, key) &&
                currentFilters[key] instanceof Array &&
                currentFilters[key].length > 0 &&
                currentFilters[key][0] !== null &&
                currentFilters[key][0] !== undefined) {
                let filter = filters.find(filter => filter.id === key);
                if (filter.type === 'search') {
                    return !card.filterProperties[key].find(property => property.toLowerCase().indexOf(currentFilters[key][0].toLowerCase()) !== -1);
                }
                return !currentFilters[key].find(property => card.filterProperties[key].includes(property));
            }

            return false;
        });
    });
}

export function execFilterCards (options) {
    filterBus.$emit('filter-cards', options);
}

export function applyFilters (passedCurrentFilters, initialFilters, applyCurrent, apply) {
    let currentFilters = jsonCopy(passedCurrentFilters);
    if (applyCurrent) {
        Object.keys(apply).forEach(key => {
            if (currentFilters[key] && currentFilters[key].allowMultiple) {
                currentFilters[key] = currentFilters[key].concat(apply[key]);
            } else {
                currentFilters[key] = apply[key];
            }
        });
    } else {
        currentFilters = { ...jsonCopy(initialFilters), ...jsonCopy(apply) };
    }

    return currentFilters;
}
